export default (showQuestionModal: boolean) => {
  if (showQuestionModal) {
    document.getElementById('app-modal-content')?.scrollTo(0, 0)
  } else {
    window.scrollTo(0, 0)
  }
}
